/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UpdateBatchViewModel {
  id?: string;
  batchType?: string | null;
  checkNumber?: string | null;
  expectedAmount?: number | null;
  payorName?: string | null;
  batchStatus?: string | null;
  postingDate?: string | null;
  defaultPaymentTypeId?: string | null;
  batchSubtype?: string | null;
}
